import TabsWidgetContainer from './TabsWidgetContainer';
import { Config } from './types';
import TabsWidgetControl from './TabsWidgetControl';
import {
  defaultBackgroundData,
  defaultBackgroundImageData,
  defaultBorderData,
  widgetTypes,
} from 'builder/util/constants';

export default ({
  type: widgetTypes.Tabs,
  displayName: 'Tabs',
  icon: 'tablet-rugged',
  initialConfig: {
    ...defaultBackgroundData,
    ...defaultBackgroundImageData,
    borderData: {
      ...defaultBorderData.borderData,
      radius: 5,
    },
    width: 1200,
    height: 600,
    xLocation: 10,
    yLocation: 10,
    uniqueId: 'tabs345',
    lineColor: '#828485',
    tabs: [
      {
        id: 0,
        name: 'Tab 1',
        required: false,
        content: '',
      },
      {
        id: 1,
        name: 'Tab 2',
        required: false,
        content: '',
      },
    ],
    currentTabIndex: 0,
    hoverFocusColor: '#ff612b',
    tabsTextColor: '#333333',
    fontSize: 16,
    font: 'OptumSans',
    backgroundData: { style: 'Color', color: 'white' },
    visible: true,
  },
  components: {
    render: TabsWidgetContainer,
    control: TabsWidgetControl,
  },
  copyable: true,
} as unknown) as HorizonWidgetDefinition<Config>;
